import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Profile from '../components/Profile';

export const PrivateRoute = ({
  isAuthenticated,
  component: Component,
  ...rest
}) => {
  //console.log('PrivateRoute isAuthenticated', isAuthenticated, 'history', history.location)
  return (
    <Route {...rest} component={(props) => (
      isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect to="/economicmodel" />
        )
    )} />
  )
};

const mapStateToProps = (state) => ({
  profile: state.globalState.profile,
  isAuthenticated: state.auth.isLoggedin
});

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/routers/PrivateRoute.js